export function ClickRainSlide(slideManager) {
	this.element = null;
	this.slideManager = slideManager;
	this.reloadToken = null;
}
ClickRainSlide.prototype.elementCreated = function(element) {
	this.element = element;
};
ClickRainSlide.prototype.prepare = function() {
	var self = this;

	// Determine which slides should be shown.
	var xhr = new XMLHttpRequest();
	xhr.open('GET', '/api/slides');
	xhr.onreadystatechange = function() {
		if (xhr.readyState === 4) {
			var response = JSON.parse(xhr.responseText);
			for (var id in response) {
				var enabled = response[id].state === 'enabled';
				self.slideManager.setSlideState(id, enabled);

				if (id === 'instagram' && response[id].state === 'enabled') {
					var igFrame = document.getElementById('livewall');
					if (igFrame !== null) {
						var igFrameSrc = igFrame.src;
						igFrame.src = igFrameSrc;
					}
				}
			}
		}
	};
	xhr.send(null);

	// In 2013, when we had issues, I needed to tell coworkers on-site that
	// they needed to go to each computer and manually refresh the page. That
	// sucks.
	//
	// So this token system lets me tell the webpage to reload itself
	// remotely. How it works is that a token is stored in the database. (This
	// token can be anything; it doesn't matter.) The first time the Click
	// Rain slide loads, it simply requests the token from the server and
	// stores it. Every other time that the Click Rain slide loads, it
	// requests the token from the server and, if the token differs from the
	// token it has stored, it reloads the page.
	//
	// So, to reload the page, one only needs to change the token in the
	// database, and eventually, the page will reload.
	//
	// That happens... HERE!
	var xhr2 = new XMLHttpRequest();
	xhr2.open('GET', '/api/tokens/reload');
	xhr2.onreadystatechange = function() {
		if (xhr2.readyState === 4) {
			var token = JSON.parse(xhr2.responseText);

			if (self.reloadToken === null) {
				// This is the first time around, so we just set the
				// reloadToken.
				self.reloadToken = token.value;
			}
			else if (self.reloadToken !== token.value) {
				// Uh oh, the reload token has changed! We need to reload the
				// page.
				window.location.reload(true);
			}
			else {
				// Sweet, the reload token that we have matches the reload
				// token that the server has. So, no need to reload.
			}
		}
	};
	xhr2.send(null);
};
ClickRainSlide.prototype.show = function() {
};
ClickRainSlide.prototype.hide = function() {
};
